import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { InputField, ErrorMessage, TooltipWidget } from 'anf-core-react';

function CVVField({
  label,
  errorMessage,
  cvv,
  index,
  onChange,
  hasValidationError,
  cardBrand,
  tooltipImage,
  tooltipMessage,
}) {
  const [localCvv, setLocalCvv] = useState(cvv);
  const [isValid, setIsValid] = useState(true);
  const maxLength = cardBrand === 'amex' ? 4 : 3;
  const id = `cvv_${index}`;

  useEffect(() => {
    setLocalCvv(cvv);
  }, [cvv]);

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, maxLength);
    setLocalCvv(value);
    onChange(value);
  };

  const handleBlur = () => {
    const valid = localCvv.length === maxLength;
    setIsValid(valid);
  };

  const showError = hasValidationError || !isValid;

  return (
    <div className="cvv-field">
      <div className="cvv-input-wrapper">
        <InputField
          id={id}
          name={id}
          value={localCvv}
          onChange={handleChange}
          onBlur={handleBlur}
          type="tel"
          maxLength={maxLength}
          placeholder={label}
          label={label}
          autoComplete="cc-csc"
          isInvalid={showError}
          aria-invalid={showError}
        >
          {showError && errorMessage && (
            <ErrorMessage>
              {errorMessage}
            </ErrorMessage>
          )}
        </InputField>
        {tooltipImage && tooltipMessage && (
          <TooltipWidget image={tooltipImage} message={tooltipMessage} />
        )}
      </div>
    </div>
  );
}

CVVField.propTypes = {
  label: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  cvv: PropTypes.string,
  index: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  hasValidationError: PropTypes.bool,
  cardBrand: PropTypes.string,
  tooltipImage: PropTypes.string,
  tooltipMessage: PropTypes.string,
};

CVVField.defaultProps = {
  errorMessage: '',
  cvv: '',
  index: 0,
  hasValidationError: false,
  cardBrand: '',
  tooltipImage: '',
  tooltipMessage: '',
};

export default CVVField;
